module.exports = __webpack_public_path__ + "img/20180120_2.bf1e5df0.jpeg";